/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningHitCountryRelation
 */
export interface ApiScreeningHitCountryRelation {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningHitCountryRelation
     */
    countryCode: string;
    /**
     * 
     * @type {ApiScreeningHitCountryRelationRelationTypeEnum}
     * @memberof ApiScreeningHitCountryRelation
     */
    relationType: ApiScreeningHitCountryRelationRelationTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiScreeningHitCountryRelationRelationTypeEnum {
    COUNTRY = 'COUNTRY',
    NATIONALITY = 'NATIONALITY',
    RESIDENCY = 'RESIDENCY',
    CITIZENSHIP = 'CITIZENSHIP'
}


/**
 * Check if a given object implements the ApiScreeningHitCountryRelation interface.
 */
export function instanceOfApiScreeningHitCountryRelation(value: object): value is ApiScreeningHitCountryRelation {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('relationType' in value) || value['relationType'] === undefined) return false;
    return true;
}

export function ApiScreeningHitCountryRelationFromJSON(json: any): ApiScreeningHitCountryRelation {
    return ApiScreeningHitCountryRelationFromJSONTyped(json, false);
}

export function ApiScreeningHitCountryRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningHitCountryRelation {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'relationType': json['relationType'],
    };
}

export function ApiScreeningHitCountryRelationToJSON(json: any): ApiScreeningHitCountryRelation {
    return ApiScreeningHitCountryRelationToJSONTyped(json, false);
}

export function ApiScreeningHitCountryRelationToJSONTyped(value?: ApiScreeningHitCountryRelation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryCode': value['countryCode'],
        'relationType': value['relationType'],
    };
}

